<template>
  <router-view />
</template>

<script>
export default {
  name: "App",

  data() {},
};
</script>

<style>
/* 전역 스타일 */
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin-top: 0;
  background-color: #f0f0f0;
  font-family: "Noto Sans KR", serif;
  text-align: center;
  color: #282828;
}

.main-layout {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  padding-top: 10px;
  &.mobile {
    padding-top: 0px;
  }
}
</style>
